import React, { useState, useRef, useEffect, useMemo } from 'react';
import { X, Bold, Italic, Underline, Plus, List, ListOrdered } from "lucide-react";
import { useDispatch, useSelector } from 'react-redux';
import Ai from '../../../assets/Ai.png'
import info from '../../../assets/information.svg'
import { Tooltip } from 'react-tooltip';
import Loader from '../../loader/Loader';
import debounce from "lodash.debounce";
import { FaLink } from "react-icons/fa";
import { getIndustries, getSkills } from '../../../services/operations/ResumesAPI';
import { createJobPost, editJobPost, writeWithAi } from '../../../services/operations/JobPostAPI';


function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

const PostNewJobPopup = ({ onClose, fetchJobs, initialData, isEdit, isClone, jobId, viewPost, filter }) => {

  const [cityInput, setCityInput] = useState('');
  const [cityTempInput, setCityTempInput] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [description, setDescription] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [contractPrice, setContractPrice] = useState('');
  const [workplaceType, setWorkplaceType] = useState(initialData?.workplace_type || 'onsite');
  const [employmentType, setEmploymentType] = useState(initialData?.employment_type || 'full-time');


  const [selectedSkills, setSelectedSkills] = useState([]);
  const [Skill, setSkill] = useState([]);
  const [skillInput, setSkillInput] = useState('');
  const [selectedSkillIndex, setSelectedSkillIndex] = useState(-1);
  const debouncedSkillInput = useDebounce(skillInput, 300);


  const [selectedNicetoHave, setSelectedNicetoHave] = useState([]);
  const [niceToHave, setNiceToHave] = useState([]);
  const [niceToHaveInput, setNiceToHaveInput] = useState('');
  const [selectedNiceToHaveIndex, setSelectedNiceToHaveIndex] = useState(-1);
  const debouncedNiceToHaveInput = useDebounce(niceToHaveInput, 300);

  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [Industry, setIndustry] = useState([]);
  const [industryInput, setIndustryInput] = useState('');
  const [selectedIndustryIndex, setSelectedIndustryIndex] = useState(-1);
  const debouncedIndustryInput = useDebounce(industryInput, 300);

  const [salaryInput, setSalaryInput] = useState("");
  const [filteredSalary, setFilteredSalary] = useState([]);
  const [selectedSalary, setSelectedSalary] = useState('');
  const [selectedSalaryIndex, setSelectedSalaryIndex] = useState(-1);
  const [showSalarySuggestions, setShowSalarySuggestions] = useState(false);

  const [experienceInput, setExperienceInput] = useState("");
  const [filteredExperience, setFilteredExperience] = useState([]);
  const [selectedExperience, setSelectedExperience] = useState([]);
  const [selectedExperienceIndex, setSelectedExperienceIndex] = useState(-1);
  const [showExperienceSuggestions, setShowExperienceSuggestions] = useState(false);

  const salaryOptions = ['$0k-$10k', '$10k-$50k', '$50k-$70k', '$70k-$90k', '$90k-$120k', '$120k-$150k', '$150k-$200k', '$200k+'];

  const [errors, setErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);

  const autocompleteRef = useRef(null);
  const autocompleteInstanceRef = useRef(null);
  const editorRef = useRef(null);
  const skillSuggestionRef = useRef(null);
  const niceToHaveSuggestionRef = useRef(null);
  const industrySuggestionRef = useRef(null);
  const salarySuggestionRef = useRef(null)
  const experienceSuggestionRef = useRef(null);
  const locationSuggestionRef = useRef(null);
  const experienceOptions = ['1-3', '3-5', '5-10', '10+'];
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const loading = useSelector((state) => state.auth.loading)
  const user = useSelector((state) => state.profile.user);

  useEffect(() => {
    if (jobTitle.trim() && errors.jobTitle) {
      setErrors(prev => ({ ...prev, jobTitle: undefined }));
    }
  }, [jobTitle, errors]);

  useEffect(() => {
    if (companyName.trim() && errors.companyName) {
      setErrors(prev => ({ ...prev, companyName: undefined }));
    }
  }, [companyName, errors]);

  useEffect(() => {
    if (cityInput.trim() && errors.cityInput) {
      setErrors(prev => ({ ...prev, cityInput: undefined }));
    }
  }, [cityInput, errors]);

  useEffect(() => {
    if (description.trim() && errors.description) {
      setErrors(prev => ({ ...prev, description: undefined }));
    }
  }, [description, errors]);

  useEffect(() => {
    if (selectedSkills.length >= 3 && errors.skills) {
      setErrors(prev => ({ ...prev, skills: undefined }));
    }
  }, [selectedSkills, errors]);


  useEffect(() => {
    if (selectedNicetoHave.length > 0 && errors.niceToHave) {
      setErrors(prev => ({ ...prev, niceToHave: undefined }));
    }
  }, [selectedNicetoHave, errors]);

  useEffect(() => {
    if (selectedIndustry.length > 0 && errors.industry) {
      setErrors(prev => ({ ...prev, industry: undefined }));
    }
  }, [selectedIndustry, errors]);

  useEffect(() => {
    if ((selectedSalary && selectedSalary !== '') || (contractPrice && contractPrice !== '')) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.salaryOrContract;
        return newErrors;
      });
    }
  }, [selectedSalary, contractPrice]);


  useEffect(() => {
    if (selectedExperience.length > 0 && errors.experienceRange) {
      setErrors(prev => ({ ...prev, experienceRange: undefined }));
    }
  }, [selectedExperience, errors]);


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        skillSuggestionRef.current &&
        !skillSuggestionRef.current.contains(event.target)
      ) {
        setSkillInput('');
      }
      if (
        niceToHaveSuggestionRef.current &&
        !niceToHaveSuggestionRef.current.contains(event.target)
      ) {
        setNiceToHaveInput('');
      }
      if (
        industrySuggestionRef.current &&
        !industrySuggestionRef.current.contains(event.target)
      ) {
        setIndustryInput('');
      }
      if (
        salarySuggestionRef.current &&
        !salarySuggestionRef.current.contains(event.target)
      ) {
        setShowSalarySuggestions(false);
        setSalaryInput('');
      }
      if (
        experienceSuggestionRef.current &&
        !experienceSuggestionRef.current.contains(event.target)
      ) {
        setShowExperienceSuggestions(false);
        setExperienceInput('');
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);



  const handleExperienceChange = (e) => {
  const input = e.target.value;
  if (input && !/^\d*\.?\d+$/.test(input)) return;

  setExperienceInput(input);

  if (!input) {
    setFilteredExperience(experienceOptions);
    setShowExperienceSuggestions(true);
    setSelectedExperienceIndex(-1);
    return;
  }

  const numericValue = parseFloat(input);

  if (!isNaN(numericValue)) {
    const matchedRanges = experienceOptions.filter((range) => {
      if (range.includes("+")) {
        const min = parseInt(range);
        return numericValue >= min;
      } else {
        const [min, max] = range.split("-").map(Number);
        return numericValue >= min && numericValue <= max;
      }
    });

    setFilteredExperience(matchedRanges.length > 0 ? matchedRanges : []);
  } else {
    setFilteredExperience(experienceOptions);
  }

  setShowExperienceSuggestions(true);
  setSelectedExperienceIndex(-1);
};


  useEffect(() => {
    if (initialData) {
      setJobTitle(initialData?.job_title);
      setCompanyName(initialData?.company_name)
      setContractPrice(initialData?.contract_price_per_hrs)
      setCityTempInput(initialData?.job_location);
      setCityInput(initialData?.job_location);
      // setWorkplaceType(initialData.workplace_type);
      // setEmploymentType(initialData.employment_type);
      setSelectedSkills(initialData?.skills ? JSON.parse(initialData.skills) : []);
      if (initialData?.nice_to_have_skills) {
        let parsed = [];
        if (typeof initialData.nice_to_have_skills === "string") {

          parsed = JSON.parse(initialData.nice_to_have_skills);
        }
        else if (Array.isArray(initialData.nice_to_have_skills)) {
          parsed = initialData.nice_to_have_skills;
        }
        setSelectedNicetoHave(parsed);
      }
      // setSelectedNicetoHave(initialData?.nice_to_have_skills ? JSON.parse(initialData.nice_to_have_skills) : []);
      setSelectedIndustry(initialData.industries ? JSON.parse(initialData.industries) : []);
      setSelectedSalary(initialData.salary_range);
      if (initialData?.experience) {
        let experiences = [];

        try {
          if (typeof initialData.experience === "string") {
            const parsed = JSON.parse(initialData.experience);
            experiences = Array.isArray(parsed) ? parsed : [parsed];
          } else if (Array.isArray(initialData.experience)) {
            experiences = initialData.experience;
          } else {
            experiences = [initialData.experience];
          }
        } catch (e) {
          experiences = [initialData.experience];
        }

        setSelectedExperience(experiences);
      }

      // setSelectedExperience(initialData?.experience ? JSON.parse(initialData.experience) : []);
      setDescription(initialData.description);
      if (editorRef.current) {
        editorRef.current.innerHTML = initialData.description;
      }
    }
  }, [initialData]);


  useEffect(() => {
    if (!window.google || !window.google.maps) return;

    if (!autocompleteInstanceRef.current && autocompleteRef.current) {
      autocompleteInstanceRef.current = new window.google.maps.places.Autocomplete(
        autocompleteRef.current,
        {
          types: ['geocode'],
          fields: ['address_components', 'formatted_address', 'place_id'],
        }
      );

      autocompleteInstanceRef.current.addListener("place_changed", () => {
        const place = autocompleteInstanceRef.current.getPlace();
        if (place && place.formatted_address) {
          setSelectedLocation(place);
          setCityInput(place.formatted_address);
          setCityTempInput(place.formatted_address);
        }
      });
    }
  }, []);



  useEffect(() => {
    getskillsList()
    getIndustryList()
  }, [])



  const filteredSkills = useMemo(() => {
    if (debouncedSkillInput.length < 2) return [];
    return Skill.filter((skill) => skill !== null).filter((skill) =>
      skill.toLowerCase().includes(debouncedSkillInput.toLowerCase())
    );
  }, [debouncedSkillInput, Skill]);


  const filteredNiceToHave = useMemo(() => {
    if (debouncedNiceToHaveInput.length < 2) return [];
    return Skill.filter((skill) => skill !== null).filter((skill) =>
      skill.toLowerCase().includes(debouncedNiceToHaveInput.toLowerCase())
    );
  }, [debouncedNiceToHaveInput, niceToHave]);

  const filteredIndustry = useMemo(() => {
    if (debouncedIndustryInput.length < 2) return [];
    return Industry
      .filter((industry) => industry !== null)
      .filter((industry) =>
        industry.toLowerCase().includes(debouncedIndustryInput.toLowerCase())
      );
  }, [debouncedIndustryInput, Industry]);

  const handleSkillsChange = (e) => {
    setSkillInput(e.target.value);
    setSelectedSkillIndex(-1)
  };


  const handleNiceToHaveChange = (e) => {
    setNiceToHaveInput(e.target.value);
    setSelectedNiceToHaveIndex(-1)
  };

  const handleIndustryChange = (e) => {
    setIndustryInput(e.target.value);
    setSelectedIndustryIndex(-1)
  };

  const handleSkillCheckbox = (skill) => {
    setSelectedSkills((prev) => {
      if (prev.includes(skill)) {
        return prev.filter((selectedSkill) => selectedSkill !== skill);
      } else {
        return prev.length < 3 ? [...prev, skill] : prev;
      }
    });
    setSkillInput('');
  };

  const handleNiceToHaveCheckbox = (skill) => {
    setSelectedNicetoHave((prev) => {
      if (prev.includes(skill)) {
        return prev.filter((selectedNicetoHave) => selectedNicetoHave !== skill);
      } else {
        return prev.length < 5 ? [...prev, skill] : prev;
      }
    });
    setNiceToHaveInput('');
  };


  const handleIndustryCheckbox = (industry) => {
    setSelectedIndustry((prev) => {
      if (prev.includes(industry)) {
        return prev.filter((selectedIndustry) => selectedIndustry !== industry);
      } else {
        return prev.length < 3 ? [...prev, industry] : prev;
      }
    });
    setIndustryInput('');
  };

  const handleSalaryCheckbox = (salary) => {
    setSelectedSalary(salary);
    setSalaryInput('');
    setShowSalarySuggestions(false);
  };

  const handleExperienceCheckbox = (experience) => {
    setSelectedExperience((prev) => {
      if (prev.includes(experience)) {
        return prev.filter((item) => item !== experience);
      } else {

        return [...prev, experience];
      }
    });
    setExperienceInput('');
    setShowExperienceSuggestions(false);
  };

  const handleSkillKeyDown = (e) => {
    if (filteredSkills.length === 0) return;

    if (e.key === 'ArrowDown') {
      setSelectedSkillIndex((prevIndex) =>
        prevIndex < filteredSkills.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === 'ArrowUp') {
      setSelectedSkillIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredSkills.length - 1
      );
    } else if (e.key === 'Enter' && selectedSkillIndex >= 0) {
      const selectedSkill = filteredSkills[selectedSkillIndex];
      handleSkillCheckbox(selectedSkill);
    }
    setTimeout(() => {
      const activeElement = document.querySelector(
        ".job-skill-suggestions .job-highlighted"
      );
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, 0);
  };

  const handleNiceToHaveKeyDown = (e) => {
    if (filteredNiceToHave.length === 0) return;

    if (e.key === 'ArrowDown') {
      setSelectedNiceToHaveIndex((prevIndex) =>
        prevIndex < filteredNiceToHave.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === 'ArrowUp') {
      setSelectedNiceToHaveIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredNiceToHave.length - 1
      );
    } else if (e.key === 'Enter' && selectedNiceToHaveIndex >= 0) {
      const selectedSkill = filteredNiceToHave[selectedNiceToHaveIndex];
      handleNiceToHaveCheckbox(selectedSkill);
    }
    setTimeout(() => {
      const activeElement = document.querySelector(
        ".job-skill-suggestions .job-highlighted"
      );
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, 0);
  };

  const handleIndustryKeyDown = (e) => {
    if (filteredIndustry.length === 0) return;

    if (e.key === 'ArrowDown') {
      setSelectedIndustryIndex((prevIndex) =>
        prevIndex < filteredIndustry.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === 'ArrowUp') {
      setSelectedIndustryIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredIndustry.length - 1
      );
    } else if (e.key === 'Enter' && selectedIndustryIndex >= 0) {
      const selectedIndustry = filteredIndustry[selectedIndustryIndex];
      handleIndustryCheckbox(selectedIndustry);
    }
    setTimeout(() => {
      const activeElement = document.querySelector(
        ".job-skill-suggestions .job-highlighted"
      );
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, 0);
  };

  const getskillsList = async () => {
    const result = await dispatch(getSkills(token))
    if (result?.data?.skills) {
      setSkill(result.data.skills)
    }
  }

  const getIndustryList = async () => {
    const result = await dispatch(getIndustries(token))
    if (result?.data?.industries) {
      setIndustry(result.data.industries)
    }
  }

  const handleAdd = (input, setInput, items, setItems, setShowInput) => {
    if (input.trim() && !items.includes(input)) {
      setItems((prev) => [...prev, input]);
    }
    setInput('');
    setShowInput(false);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!companyName.trim()) newErrors.companyName = 'Company Name is required';
    if (!jobTitle.trim()) newErrors.jobTitle = 'Job title is required';
    if (!cityInput.trim()) newErrors.cityInput = 'Job location is required';

    if (selectedSkills.length < 3) {
      const remaining = 3 - selectedSkills.length;
      if (selectedSkills.length === 0) {
        newErrors.skills = "Please select 3 skills";
      } else {
        newErrors.skills = `Please add ${remaining} more skill${remaining > 1 ? "s" : ""}`;
      }
    }
    if (selectedNicetoHave.length === 0) newErrors.niceToHave = 'Add at least 1 skill or more';
    // if (selectedIndustry.length === 0) newErrors.industry = 'Atleast one industry is required';
    if (!description) newErrors.description = "Job description is required";
    if (selectedExperience.length === 0) newErrors.experienceRange = "Experience range is required";
    // const isSalaryFilled = selectedSalary && selectedSalary !== '';
    // const isContractFilled = contractPrice && contractPrice !== '';

    // if (!isSalaryFilled && !isContractFilled) {
    //   newErrors.salaryOrContract = "Enter either salary range or contract rate";
    // }

    console.log("err", newErrors)
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const validateFieldsForAi = () => {
    const newErrors = {};
    if (!companyName.trim()) newErrors.companyName = 'Company Name is required';
    if (!jobTitle.trim()) newErrors.jobTitle = 'Job title is required';
    if (!cityInput.trim()) newErrors.cityInput = 'Job location is required';
    if (selectedSkills.length < 3) {
      const remaining = 3 - selectedSkills.length;
      if (selectedSkills.length === 0) {
        newErrors.skills = "Please select 3 skills";
      } else {
        newErrors.skills = `Please add ${remaining} more skill${remaining > 1 ? "s" : ""}`;
      }
    }
    if (selectedNicetoHave.length === 0) newErrors.niceToHave = 'Add at least 1 skill or more';
    if (selectedIndustry.length === 0) newErrors.industry = 'Atleast one industry is required';
    //if (!selectedSalary) newErrors.salaryRange = 'Salary range is required';
    if (selectedExperience.length === 0) newErrors.experienceRange = "Experience range is required";
    const isSalaryFilled = selectedSalary && selectedSalary !== '';
    const isContractFilled = contractPrice && contractPrice !== '';

    if (!isSalaryFilled && !isContractFilled) {
      newErrors.salaryOrContract = "Enter either salary range or contract rate";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRemove = (index, setItems) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const formatText = (tag) => {
    if (editorRef.current) {
      document.execCommand(tag, false, null);
      editorRef.current.focus();
    }
  };
  const handleClearDraft = () => {
    setDescription('');
    if (editorRef.current) {
      editorRef.current.innerHTML = '';
    }
  };
  const allFieldsFilled = jobTitle && cityTempInput && description && selectedSkills.length > 0 && selectedIndustry.length > 0 && ((selectedSalary && selectedSalary !== '') || (contractPrice && contractPrice !== '')) && selectedExperience !== "";

  const isSalaryFilled = selectedSalary && selectedSalary !== '';
  const isContractFilled = contractPrice && contractPrice !== '';


  const addList = (type) => {
    if (editorRef.current) {
      document.execCommand(type === 'unordered' ? 'insertUnorderedList' : 'insertOrderedList', false, null);
      editorRef.current.focus();
    }
  };

  const addLink = () => {
    if (editorRef.current) {
      const selection = window.getSelection();
      if (!selection.rangeCount) return;

      const selectedText = selection.toString().trim();
      if (!selectedText) return;

      const url = selectedText.startsWith("http") ? selectedText : `https://${selectedText}`;
      document.execCommand("createLink", false, url);
      editorRef.current.focus();
    }
  };

  const writeAi = async () => {
    if (!validateFieldsForAi()) return;
    const payload = {
      company_name: companyName,
      job_title: jobTitle,
      job_location: cityInput,
      workplace_type: workplaceType,
      employment_type: employmentType,
      industries: selectedIndustry,
      skills: selectedSkills,
      experience_range: selectedExperience,
      description: description,
      nice_to_have_skills: selectedNicetoHave
    }
    if (selectedSalary) {
      payload.salary_range = selectedSalary;
    } else if (contractPrice) {
      payload.contract_price_per_hrs = contractPrice;
    }

    const result = await dispatch(writeWithAi(payload, token))
    if (result?.data?.description) {
      setDescription(result.data.description);
      if (editorRef.current) {
        editorRef.current.innerHTML = result.data.description;
      }
    }
  }

  const handleCreateJob = async (isDraft) => {
    // if (!validateFields()) return;

    if (!validateFields()) {
      console.log("Validation failed"); // debug
      return; // stop API call
    }

    let jobStatus = ''

    if (isDraft === true) {
      jobStatus = "DRAFT"
    }
    else {
      jobStatus = "ACTIVE"
    }
    const payload = {
      company_name: companyName,
      job_title: jobTitle,
      job_location: cityInput,
      workplace_type: workplaceType,
      employment_type: employmentType,
      industries: selectedIndustry,
      description: description,
      experience: selectedExperience,
      skills: selectedSkills,
      job_status: jobStatus,
      nice_to_have_skills: selectedNicetoHave
    };

    if (selectedSalary) {
      payload.salary_range = selectedSalary;
    } else if (contractPrice) {
      payload.contract_price_per_hrs = contractPrice;
    }

    if (isEdit) {
      await dispatch(editJobPost(payload, token, onClose, jobId));
      viewPost()
    }
    else if (isClone) {
      await dispatch(createJobPost(payload, token, onClose))
    }
    else {
      await dispatch(createJobPost(payload, token, onClose))
      fetchJobs()
    }

  }

  const handlePreview = () => {
    if (!validateFields()) return;
    setShowPreview(true);
  };

  const handleSalaryChange = (e) => {
    const input = e.target.value.trim();

    if (input && !/^\d*\.?\d*k?$/.test(input)) return;
    setSalaryInput(input);

    if (!input) {
      setFilteredSalary(salaryOptions);
      setShowSalarySuggestions(true);
      setSelectedSalaryIndex(-1);
      return;
    }

    let numericValue = parseFloat(input.replace("k", "")) * (input.includes("k") ? 1000 : 1);

    if (!isNaN(numericValue)) {
      const matchedRanges = salaryOptions.filter((range) => {
        const cleanedRange = range.replace(/\$/g, "").replace(/k/g, "000");

        if (cleanedRange.includes("+")) {
          const min = parseInt(cleanedRange.replace("+", ""), 10);
          return numericValue >= min;
        } else {
          const [min, max] = cleanedRange.split("-").map(Number);
          return numericValue >= min && numericValue <= max;
        }
      });

      setFilteredSalary(matchedRanges.length > 0 ? matchedRanges : []);
    } else {
      setFilteredSalary([]);
    }

    setShowSalarySuggestions(true);
    setSelectedSalaryIndex(-1);
  };

  const handleSalaryKeyDown = (e) => {

    if (filteredSalary.length === 0) return;

    if (e.key === 'ArrowDown') {
      setSelectedSalaryIndex((prevIndex) =>
        prevIndex < filteredSalary.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === 'ArrowUp') {
      setSelectedSalaryIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredSalary.length - 1
      );
    } else if (e.key === 'Enter' && selectedSalaryIndex >= 0) {
      const selectedSalary = filteredSalary[selectedSalaryIndex];
      handleSalaryCheckbox(selectedSalary);
    }
    setTimeout(() => {
      const activeElement = document.querySelector(
        ".job-skill-suggestions .job-highlighted"
      );
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, 0);
  };

  const handleExperienceKeyDown = (e) => {

    if (filteredExperience.length === 0) return;

    if (e.key === 'ArrowDown') {
      setSelectedExperienceIndex((prevIndex) =>
        prevIndex < filteredExperience.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === 'ArrowUp') {
      setSelectedExperienceIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredExperience.length - 1
      );
    } else if (e.key === 'Enter' && selectedExperienceIndex >= 0) {
      const selectedExperience = filteredExperience[selectedExperienceIndex];
      handleExperienceCheckbox(selectedExperience);
    }
    setTimeout(() => {
      const activeElement = document.querySelector(
        ".job-skill-suggestions .job-highlighted"
      );
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, 0);
  };


  return (
    <div className='job-popup-overlay'>
      {loading && <Loader />}
      <div className='job-popup' onClick={(e) => e.stopPropagation()}>
        <div className="job-popup-header">
          <p> {isEdit ? 'Edit job posting' : isClone ? 'Clone job posting' : 'Add job posting'} description</p>
          <X className="close-icon" onClick={onClose} />
        </div>
        <div className='jobpost-form'>
          <p className='popup-company-name'>Company *</p>
          <div className='popup-compnay-desc'>
            <input type='text' className='job-title' placeholder='Company Name' value={companyName} onChange={(e) => setCompanyName(e.target.value)}
              style={{ width: "34%" }} />
            {errors.companyName && <p className="error-message-jobpost">{errors.companyName}</p>}
          </div>
          <div className='job-popup-content'>
            <p style={{ margin: "25px 0px 13px 0px", fontSize: "20px" }}>Job details</p>
            <div className='row'>
              <div className='col'>
                <label>Job Title *</label>
                <input type='text' className='job-title' placeholder='Job Title' value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} />
                {errors.jobTitle && <p className="error-message-jobpost">{errors.jobTitle}</p>}
              </div>
              <div className='col'>
                <label>Employment type *</label>
                <select value={employmentType} onChange={(e) => setEmploymentType(e.target.value)}>
                  <option value="Full-time">Full-time</option>
                  <option value="Part-time">Part-time</option>
                  <option value="Contract">Contract</option>
                  <option value="Temporary">Temporary</option>
                  <option value="Volunteer">Volunteer</option>
                  <option value="Internship">Internship</option>
                </select>
              </div>
            </div>
            <div className='row'>

              <div className='col'>
                <label>Workplace type *</label>
                <select value={workplaceType} onChange={(e) => setWorkplaceType(e.target.value)}>
                  <option value="Onsite" style={{ fontSize: "14px" }}>Onsite</option>
                  {/* <option disabled style={{ fontSize: "14px" }}>Employees come to work in person.</option> */}

                  <option value="Remote" style={{ fontSize: "14px" }}>Remote</option>
                  {/* <option disabled style={{ fontSize: "14px" }}>Work from any location</option> */}

                  <option value="Hybrid" style={{ fontSize: "14px" }}>Hybrid</option>
                  {/* <option disabled style={{ fontSize: "14px" }}>Employees work on-site and off-site.</option> */}

                </select>

              </div>
              <div className='col'>
                <label>Job Location *</label>
                <input
                  ref={autocompleteRef}
                  className="job-location-input"
                  placeholder='City or metro Area'
                  value={cityTempInput}
                  onChange={(e) => setCityTempInput(e.target.value)}
                  onBlur={() => {
                    if (!selectedLocation || cityTempInput !== selectedLocation.formatted_address) {
                      setCityTempInput("");
                      setCityInput("");
                    }
                  }}
                  autoComplete="off"
                />
                <p style={{ alignItems: "center", display: "flex", gap: "5px" }}><img src={info} alt='infoTip' style={{ marginTop: "-5px" }} /><span style={{ fontSize: "11px", color: "rgba(122, 122, 122, 1)", marginTop: "5px" }}>This Job will be shown to job seekers searching for on site jobs in this location.</span></p>
                {errors.cityInput && <p className="error-message-jobpost">{errors.cityInput}</p>}
              </div>
            </div>
          </div>
          <div className='job-popup-content'>
            <p style={{ margin: "15px 0px", fontSize: "20px" }}>Profile Details</p>
            <div className='row'>
              <div className='col'>
                <p className='jobpost-profile-detials-row-label'>Mandatory Skills (select 3*)
                  <img
                    src={info}
                    alt="infoTip"
                    data-tooltip-id="skills-tooltip"
                    style={{ width: "12px", height: "12px", marginLeft: "5px", cursor: "pointer" }}
                  />
                  <Tooltip id="skills-tooltip" place="top" effect="solid" style={{ fontSize: "10px", backgroundColor: "rgba(45, 118, 253, 1)", borderRadius: "10px" }}>
                    These skills will appear on the job post and be used to show the listing to relevant candidtes.
                  </Tooltip>
                </p>
                <div className="job-filter-dropdown">
                  <input
                    id="skills"
                    placeholder="Add Skill"
                    className="job-skill-input"
                    autoComplete="off"
                    value={skillInput}
                    onChange={handleSkillsChange}
                    onKeyDown={handleSkillKeyDown}
                  />
                  {filteredSkills.length > 0 && (
                    <div ref={skillSuggestionRef} className="job-skill-suggestions">
                      {filteredSkills.map((skill, index) => (
                        <div
                          key={index}
                          className={`job-skill-suggestion ${index === selectedSkillIndex ? 'job-highlighted' : ''}`}
                          onMouseEnter={() => setSelectedSkillIndex(index)}
                          onClick={(e) => {
                            if (e.target.type !== 'checkbox') handleSkillCheckbox(skill);
                          }}
                        >
                          <input
                            type="checkbox"
                            className='checkbox-list'
                            checked={selectedSkills.includes(skill)}
                            onChange={() => handleSkillCheckbox(skill)}
                          />
                          <label className='skill-label'>{skill}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className='job-tag-container'>
                  {selectedSkills.map((skill, index) => (
                    <span key={index} className='job-tag'>
                      {skill} <X size={12} onClick={() => handleRemove(index, setSelectedSkills)} />
                    </span>
                  ))}
                </div>
                {errors.skills && <p className="error-message-jobpost">{errors.skills}</p>}
              </div>
              <div className='col'>
                <p className='jobpost-profile-detials-row-label'>Nice to have(select upto 5*)
                  <img
                    src={info}
                    alt="infoTip"
                    data-tooltip-id="skills-tooltip"
                    style={{ width: "12px", height: "12px", marginLeft: "5px", cursor: "pointer" }}
                  />
                  <Tooltip id="skills-tooltip" place="top" effect="solid" style={{ fontSize: "10px", backgroundColor: "rgba(45, 118, 253, 1)", borderRadius: "10px" }}>
                    These skills will appear on the job post and be used to show the listing to relevant candidtes.
                  </Tooltip>
                </p>
                <div className="job-filter-dropdown">
                  <input
                    id="skills"
                    placeholder="Add"
                    className="job-skill-input"
                    autoComplete="off"
                    value={niceToHaveInput}
                    onChange={handleNiceToHaveChange}
                    onKeyDown={handleNiceToHaveKeyDown}
                  />
                  {filteredNiceToHave.length > 0 && (
                    <div ref={niceToHaveSuggestionRef} className="job-skill-suggestions">
                      {filteredNiceToHave.map((skill, index) => (
                        <div
                          key={index}
                          className={`job-skill-suggestion ${index === selectedNiceToHaveIndex ? 'job-highlighted' : ''}`}
                          onMouseEnter={() => setSelectedNiceToHaveIndex(index)}
                          onClick={(e) => {
                            if (e.target.type !== 'checkbox') handleNiceToHaveCheckbox(skill);
                          }}
                        >
                          <input
                            type="checkbox"
                            className='checkbox-list'
                            checked={selectedNicetoHave.includes(skill)}
                            onChange={() => handleNiceToHaveCheckbox(skill)}
                          />
                          <label className='skill-label'>{skill}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className='job-tag-container'>
                  {selectedNicetoHave?.map((skill, index) => (
                    <span key={index} className='job-tag'>
                      {skill} <X size={12} onClick={() => handleRemove(index, setSelectedNicetoHave)} />
                    </span>
                  ))}
                </div>
                {errors.niceToHave && <p className="error-message-jobpost">{errors.niceToHave}</p>}
              </div>
            </div>
            <div className='row'>
              <div className='col'>
                <p className='jobpost-profile-detials-row-label'>Experience Range *</p>
                <div className="job-filter-dropdown">
                  <input
                    id="experience"
                    placeholder="Type here"
                    className="job-skill-input"
                    autoComplete="off"
                    value={experienceInput}
                    // style={{ width: "30%" }}
                    onChange={handleExperienceChange}
                    onKeyDown={handleExperienceKeyDown}
                  />
                  {showExperienceSuggestions && filteredExperience.length > 0 && (
                    <div ref={experienceSuggestionRef} className="job-skill-suggestions">
                      {filteredExperience.map((experience, index) => (
                        <div
                          key={index}
                          className={`job-skill-suggestion ${index === selectedExperienceIndex ? "job-highlighted" : ""
                            }`}
                          onMouseEnter={() => setSelectedExperienceIndex(index)}
                          onClick={(e) => {
                            if (e.target.type !== "checkbox") handleExperienceCheckbox(experience);
                          }}
                        >
                          <input
                            type="checkbox"
                            className="checkbox-list"
                            checked={selectedExperience?.includes(experience)}
                            onChange={() => handleExperienceCheckbox(experience)}
                          />
                          <label className="skill-label">{experience}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className='job-tag-container'>
                  {selectedExperience.map((skill, index) => (
                    <span key={index} className='job-tag'>
                      {skill} <X size={12} onClick={() => handleRemove(index, setSelectedExperience)} />
                    </span>
                  ))}
                </div>
                {errors.experienceRange && <p className="error-message-jobpost">{errors.experienceRange}</p>}
              </div>
              <div className='col'>
                <p className='jobpost-profile-detials-row-label'>Add Industry ( Select up to 3*)
                </p>
                <div className="job-filter-dropdown">
                  <input
                    id="skills"
                    placeholder="Add Industry"
                    className="job-skill-input"
                    autoComplete="off"
                    value={industryInput}
                    onChange={handleIndustryChange}
                    onKeyDown={handleIndustryKeyDown}
                  />
                  {filteredIndustry.length > 0 && (
                    <div ref={industrySuggestionRef} className="job-skill-suggestions">
                      {filteredIndustry.map((skill, index) => (
                        <div
                          key={index}
                          className={`job-skill-suggestion ${index === selectedIndustryIndex ? 'job-highlighted' : ''}`}
                          onMouseEnter={() => setSelectedIndustryIndex(index)}
                          onClick={(e) => {
                            if (e.target.type !== 'checkbox') handleIndustryCheckbox(skill);
                          }}
                        >
                          <input
                            type="checkbox"
                            className='checkbox-list'
                            checked={selectedIndustry.includes(skill)}
                            onChange={() => handleIndustryCheckbox(skill)}
                          />
                          <label className='skill-label'>{skill}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className='job-tag-container'>
                  {selectedIndustry.map((industry, index) => (
                    <span key={index} className='job-tag'>
                      {industry} <X size={12} onClick={() => handleRemove(index, setSelectedIndustry)} />
                    </span>
                  ))}
                </div>
                {errors.industry && <p className="error-message-jobpost">{errors.industry}</p>}
              </div>
            </div>
            <div className='row' style={{ gap: "40px", marginBottom: "5px" }}>
              <div className='col'>
                <p className='jobpost-profile-detials-row-label'>Salary range (Annually)*</p>
                <div className="job-filter-dropdown">
                  <input
                    id="salary"
                    placeholder="Type here"
                    className="job-skill-input"
                    autoComplete="off"
                    value={salaryInput}
                    onChange={handleSalaryChange}
                    onKeyDown={handleSalaryKeyDown}
                    disabled={isContractFilled}
                  />
                  {showSalarySuggestions && filteredSalary.length > 0 && (
                    <div ref={salarySuggestionRef} className="job-skill-suggestions">
                      {filteredSalary.map((salary, index) => (
                        <div
                          key={index}
                          className={`job-skill-suggestion ${index === selectedSalaryIndex ? "job-highlighted" : ""
                            }`}
                          onMouseEnter={() => setSelectedSalaryIndex(index)}
                          onClick={(e) => {
                            if (e.target.type !== "checkbox") handleSalaryCheckbox(salary);
                          }}
                        >
                          <input
                            type="checkbox"
                            className="checkbox-list"
                            checked={selectedSalary?.includes(salary)}
                            onChange={() => handleSalaryCheckbox(salary)}
                            disabled={isContractFilled}
                          />
                          <label className="skill-label">{salary}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className='job-tag-container'>
                  {selectedSalary && (
                    <span className='job-tag'>
                      {selectedSalary}
                      <X size={12} onClick={() => setSelectedSalary('')} />
                    </span>
                  )}
                </div>
              </div>
              <div className="col custom-divider-jobpost">
                <div style={{ height: "20%", width: "1px", backgroundColor: "#ccc" }}></div>
                <span style={{ margin: "4px 0" }}>OR</span>
                <div style={{ height: "20%", width: "1px", backgroundColor: "#ccc" }}></div>
              </div>
              <div className="col">
                <p className="jobpost-profile-detials-row-label">Contract</p>
                <div className="contract-input-wrapper">
                  <span className="dollar-sign">$</span>
                  <input
                    type="number"
                    className="job-skill-input contract-input"
                    placeholder="Enter value"
                    value={contractPrice}
                    onChange={(e) => setContractPrice(e.target.value)}
                    min="0"
                    disabled={isSalaryFilled}
                  />
                  <span className="per-hour-label">/hr</span>
                </div>
                {/* {!isSalaryFilled && errors.salaryOrContract && (
                  <p className="error-message-jobpost">{errors.salaryOrContract}</p>
                )} */}
              </div>
            </div>
            {errors.salaryOrContract && (
              <div style={{ width: "100%", textAlign: "left", marginBottom: "8px" }}>
                <p className="error-message-jobpost">{errors.salaryOrContract}</p>
              </div>
            )}
          </div>
          <div className='job-popup-content' style={{ width: "100%" }}>
            <p style={{ display: "flex", alignItems: "center" }}>
              <span style={{ margin: "10px 0px", color: "rgba(122, 122, 122, 1)", fontSize: "14px" }}>Job description*</span>
              <img
                src={info}
                alt="infoTip"
                data-tooltip-id="desc-tooltip"
                style={{ width: "12px", height: "12px", marginLeft: "5px", cursor: "pointer" }}
              />
              <Tooltip id="desc-tooltip" place="top" effect="solid" style={{ fontSize: "10px", backgroundColor: "rgba(45, 118, 253, 1)", borderRadius: "10px" }}>
                Reformat with AI helps you update the formatting of your job description
                to make them more readable please review before submitting.
              </Tooltip></p>
            <div className='text-editor-container'>

              <div className='text-editor'>
                <div className='text-editor-toolbar'>
                  <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
                    <button className='fontMeth' onClick={() => formatText('bold')}><Bold style={{ width: "18px", height: "18px" }} /></button>
                    <button className='fontMeth' onClick={() => formatText('italic')}><Italic style={{ width: "18px", height: "18px" }} /></button>
                    <button className='fontMeth' onClick={addLink} style={{ width: "15px", height: "18px", fontSize: "12px" }}><FaLink style={{ fontSize: "14px" }} /></button>
                    <button className='fontMeth' onClick={() => addList('unordered')}><List style={{ width: "18px", height: "18px" }} /></button>
                    <button className='fontMeth' onClick={() => addList('ordered')}><ListOrdered style={{ width: "18px", height: "18px" }} /></button>
                  </div>
                  <div className='text-actions'>
                    <button className='ai-btn' onClick={writeAi}><img src={Ai} alt='ai' style={{ width: "24px", height: "24px" }} />{description !== "" ? "Rewrite" : "Write"} with AI</button>
                    <button className='clear-btn' onClick={handleClearDraft}>Clear Draft</button>
                  </div>
                </div>


                <div
                  ref={editorRef}
                  className='text-editor-input'
                  contentEditable={true}
                  dir="ltr"
                  onInput={(e) => setDescription(e.target.innerHTML)}
                  //dangerouslySetInnerHTML={{ __html: description }}
                  style={{ minHeight: "150px", outline: "none", padding: "10px" }}
                />
              </div>
            </div>
            {errors.description && <p className="error-message-jobpost">{errors.description}</p>}
          </div>
          <div className='job-popup-content' style={{ width: "50%", margin: "10px 0px", color: "red", fontSize: "12px" }}>
            {isClone && <p>* Review the job description</p>}
          </div>
          <div className='job-popup-actions'>
            <button className='job-draft-btn' onClick={() => handleCreateJob(true)}>
              {isEdit && filter === "active" ? "Move to Draft" :
                isEdit && filter === "draft" ? "Update Draft" :
                  isClone && filter === "closed" ? "Save as Draft" :
                    "Save as Draft"}
            </button>
            <button className='job-preview-btn' onClick={handlePreview}
              disabled={!allFieldsFilled}
              style={{
                background: allFieldsFilled ? '#0002DC' : 'rgba(173, 201, 254, 1);',

              }}
            >Preview</button>
            <button className='job-publish-btn' onClick={() => handleCreateJob(false)}>
              {isEdit && filter === "active" ? "Update" :
                isEdit && filter === "draft" ? "Publish" :
                  isClone && filter === "closed" ? "Clone & Publish" :
                    "Publish"}
            </button>
          </div>
        </div>
      </div>
      {showPreview && (
        <div className='preview-popup-overlay' onClick={() => setShowPreview(false)}>
          <div className='preview-popup' onClick={(e) => e.stopPropagation()}>
            <div className="job-popup-preview-header">
              <p>Review job posting description</p>
              <X className="close-icon" onClick={() => setShowPreview(false)} />
            </div>

            <div className='preview-content'>
              <p style={{ fontSize: "18px", fontWeight: "600" }}>{jobTitle}</p>
              <p className='jobdetail-company-name'>{companyName}</p>

              <p style={{ color: "rgba(0,0,0,0.5)", fontSize: "12px" }}>{cityInput}</p>
              <div className='jobpost-detail-first'>
                <p className='jobpost-detail-work-type'>{workplaceType}</p>
                <p className='jobpost-detail-work-type'>{employmentType}</p>
              </div>
              <p><strong>About the job</strong></p>
              <div
                style={{
                  all: "unset",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  fontSize: "11px",
                  fontWeight: "400",
                  lineHeight: "1.5",
                }}
                dangerouslySetInnerHTML={{ __html: description }} />
              <p style={{ fontWeight: "600", fontSize: "16px", marginTop: '5px' }}>Skills required</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {selectedSkills.map((skill, index) => (
                  <span
                    key={index}
                    style={{
                      background: 'white',
                      padding: '5px 10px',
                      borderRadius: '20px',
                      fontSize: '14px',
                      border: "0.5px solid #0002DC",
                      color: "#0002DC"
                    }}
                  >
                    {skill}
                  </span>
                ))}
              </div>
              <p style={{ fontWeight: "600", fontSize: "16px", marginTop: '5px' }}>Industry </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {selectedIndustry.map((skill, index) => (
                  <span
                    key={index}
                    style={{
                      background: 'white',
                      padding: '5px 10px',
                      borderRadius: '20px',
                      fontSize: '14px',
                      border: "0.5px solid #0002DC",
                      color: "#0002DC"
                    }}
                  >
                    {skill}
                  </span>
                ))}
              </div>
              <p style={{ fontWeight: "600", fontSize: "16px", marginTop: '5px' }}>ExperienceRequired</p>
              <p>{selectedExperience} Years</p>
              {selectedSalary !== "" && (
                <>
                  <p style={{ fontWeight: "600", fontSize: "16px", marginTop: '5px' }}>Expected Salary</p>
                  <p>{selectedSalary}</p>
                </>
              )}
              {contractPrice && (<>
                <p style={{ fontWeight: "600", fontSize: "16px", marginTop: '5px' }}>Contract Pay</p>
                <p>${contractPrice}/hr</p>
              </>)}

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default PostNewJobPopup;
